// extracted by mini-css-extract-plugin
export var btn = "button-module--btn--sx20t";
export var hollow = "button-module--hollow--DKtbP";